import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const StatusMissingIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 12 12" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M7 10.9a5 5 0 0 1-2 0l.4-1.8a3.2 3.2 0 0 0 1.2 0L7 11Zm-3.8-.7 1-1.6-.8-.8-1.6 1 1.4 1.4ZM1.1 7l1.8-.4a3.2 3.2 0 0 1 0-1.2L1 5a5 5 0 0 0 0 2Zm.7-3.8 1.6 1 .8-.8-1-1.6a5 5 0 0 0-1.4 1.4ZM5 1.1a5 5 0 0 1 2 0l-.4 1.8a3.2 3.2 0 0 0-1.2 0L5 1Zm3.8.7-1 1.6.8.8 1.6-1a5 5 0 0 0-1.4-1.4ZM10.9 5l-1.8.4a3.2 3.2 0 0 1 0 1.2L11 7a5 5 0 0 0 0-2Zm-.7 3.8-1.6-1-.8.8 1 1.6a5 5 0 0 0 1.4-1.4Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default StatusMissingIcon;
